module.exports = __webpack_public_path__ + "img/banner.c54bf2b6.jpg";